var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "print-list_box" },
    [
      _c(
        "el-tabs",
        {
          staticClass: "y-b-0",
          attrs: { type: "border-card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "平台回收明细", name: "ecomdetail" } },
            [_vm.activeTab === "ecomdetail" ? _c("pDetail") : _vm._e()],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "客户编码回收明细", name: "kdetail" } },
            [_vm.activeTab === "kdetail" ? _c("kDetail") : _vm._e()],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }